import { createAction } from '@reduxjs/toolkit'

/**
 * Границы области состояния (D-075, F07).
 *
 * Слайсы пакетов не знают, КТО и КОГДА завершает сессию: они подписываются на
 * эти два действия в `extraReducers` и сами чистят своё. Так пакет не
 * импортирует ни приложение, ни соседа, а очистка не держится на памяти
 * того, кто пишет кнопку «Выйти».
 */

/**
 * Пользовательская область закончилась: выход, истёкшая сессия, вход другого
 * человека на том же устройстве. Всё намерение, принадлежащее пользователю
 * (черновики, выбор, вкладки), удаляется; device-настройки (тема) остаются.
 */
export const userScopeCleared = createAction('scope/userCleared')

/**
 * Ресурс больше не в работе у этого клиента: отключён, удалён, человек
 * переключил окно на другой rid. Слайсы удаляют записи с этим rid в ключе;
 * запросы с ним перечитываются по тегу области (`resourceScopeTag`); неподписанные
 * записи кэша уходят по `keepUnusedDataFor`.
 */
export const resourceScopeCleared = createAction<{ resourceId: string }>('scope/resourceCleared')
